import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";
import { LogoMark } from "@/components/Brand";

export default function ForgotPassword() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get("email") || "");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { const r = await api.post("/auth/forgot-password", { email }); setDone(r.data.message); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || "Something went wrong. Please try again."); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="forgot-password-page">
      <div className="w-full max-w-sm animate-fade-up">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-8"><ArrowLeft className="w-4 h-4" /> Back to sign in</Link>
        <LogoMark className="w-10 h-10 mb-4" />
        <h1 className="font-display text-3xl font-bold tracking-tight mb-1">Forgot your password?</h1>
        <p className="text-muted-foreground mb-8 text-sm">Enter your account email and we'll send a one-hour reset link.</p>
        {done ? (
          <div className="rounded-xl border border-border bg-card p-5 text-sm flex gap-3" data-testid="forgot-password-sent">
            <MailCheck className="w-5 h-5 text-accent shrink-0" /><p>{done}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5" placeholder="you@careservice.co.uk" data-testid="forgot-email-input" />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="forgot-error">{error}</p>}
            <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
